import 'intersection-observer';
import domReady from '../helpers/dom-ready';

export default class InView {
  static init() {
    return new InView();
  }

  constructor() {
    this.items = [...document.querySelectorAll('.hotspot, .animate-me')];

    this.load();
  }

  show(element) {
    if (!element.classList.contains('animate-me')) {
      element.classList.add('-in-view');
    }
  }

  load() {
    const animations = [
      'fadeInOpacity',
      'slideInRight',
      'slideInLeft',
      'slideInBottom',
      'slideInTop',
      'slideInContent',
      'fadeInCharacters',
    ];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // in view
          if (entry.intersectionRatio > 0) {
            this.show(entry.target);
            // eslint-disable-next-line no-restricted-syntax
            for (const animation of animations) {
              if (entry.target.classList.contains(animation)) {
                // eslint-disable-next-line no-param-reassign
                entry.target.classList.add(`animate-${animation}`);
              }
            }

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: [0.0, 0.25], // [0, 0.25, 0.5, 1],
        rootMargin: '0px 0px -15% 0px',
      },
    );

    for (let i = 0; i < this.items.length; i += 1) {
      const item = this.items[i];

      observer.observe(item);
    }
  }
}

domReady(() => {
  InView.init();
});
